import { NumericFormat, type NumericFormatProps } from 'react-number-format'

import { cn } from '@/lib/cn'

type CurrencyInputProps = {
  value?: number
  onChange: (value: string) => void
  error?: string
} & NumericFormatProps

const CurrencyInput = ({
  value,
  onChange,
  error,
  ...props
}: CurrencyInputProps) => {
  return (
    <NumericFormat
      value={value}
      onValueChange={(values) => {
        const { value } = values
        onChange(value)
      }}
      thousandSeparator="."
      decimalSeparator=","
      prefix="R$ "
      decimalScale={2}
      fixedDecimalScale
      allowNegative={false}
      className={cn(
        'w-full border-none bg-transparent font-inter text-sm font-normal text-system-text-primary outline-none placeholder:text-system-text-placeholder',
        error && 'border-system-error',
      )}
      {...props}
    />
  )
}

export { CurrencyInput }
